















































































import { Vue, Component, Watch } from 'vue-property-decorator';
import XAdminHeader from './components/admin/header.vue';
import XAdminMenu from './components/admin/menu.vue';
import XHeader from './components/header.vue';
import XMenu from './components/menu.vue';
import { UserTypes } from '@/enums/userTypes';

@Component({
  name: 'app',
  components: {
    'x-admin-header': XAdminHeader,
    'x-admin-menu': XAdminMenu,
    'x-header': XHeader,
    'x-menu': XMenu
  }
})
export default class App extends Vue {
  private isCollapse = false;
  private isMiniCollapse = true;
  private UserTypes = UserTypes;

  get isMini(): boolean {
    return (this as any).$mq === 'mini';
  }

  get isSmall(): boolean {
    return (this as any).$mq === 'small';
  }

  get isLarge(): boolean {
    return (this as any).$mq === 'large';
  }

  get userRole(): UserTypes {
    return this.$store.getters['auth/userType'];
  }

  @Watch('isMini')
  private onIsMiniChanged(value: boolean) {
    if (value) {
      this.isMiniCollapse = true;
    }
  }

  @Watch('isSmall')
  private onIsSmallChanged(value: boolean) {
    if (value) {
      this.isCollapse = true;
    }
  }

  @Watch('isLarge')
  private onIsLargeChanged(value: boolean) {
    if (value) {
      this.isCollapse = false;
    }
  }

  private onClickMenu() {
    if (this.isMini) {
      this.isMiniCollapse = !this.isMiniCollapse;
    } else {
      this.isCollapse = !this.isCollapse;
    }
  }

  private onSelectMenu() {
    this.isMiniCollapse = true;
  }
}
